module.exports = __webpack_public_path__ + "img/Cover_FS_19.451d912b.jpg";